
<c-contract-editor
    :title     = "$t('contract.esc.fulltitle')"
    :unit-data = "unitData"
    @store     = "onStore"
    @edit      = "onEdit"
    @start     = "onStart"
    @end       = "onEnde"
>
    <template v-slot:additional>
        <v-row class="no-frame">
            <v-col class="no-frame pr-1  col-4">
                <f-currency-field-rw
                    class="mt-1"
                    :label        = "$t('contract.esc.costs')"
                    :readonly     = "readonly"
                    v-model       = "unitData.costs"
                    :hide-details = "true"
                />
            </v-col>
            <v-col class="no-frame col-4">
                <f-enum-select-rw
                    v-model       = "unitData.gadget"
                    :label        = "$t('contract.esc.gadgetRent')"
                    :readonly     = "readonly"
                    module        = "msd"
                    type          = "escGadgetRentType"
                    :hide-details = "true"
                />
            </v-col>
            <v-col class="no-frame pl-1 col-4">
                <f-currency-field-rw
                    class="mt-1"
                    :label        = "$t('contract.esc.rentPerYear')"
                    :readonly     = "readonly"
                    v-model       = "unitData.rent"
                    :hide-details = "true"
                />
            </v-col>

        </v-row>

        <v-row class="no-frame mt-1">
            <v-col class="no-frame pr-1 col-4">
                <f-currency-field-rw
                    :label        = "$t('contract.esc.standByPerYear')"
                    :readonly     = "readonly"
                    v-model       = "unitData.standBy"
                    :hide-details = "true"
                />
            </v-col>

            <v-col class="no-frame col-4">
                <f-currency-field-rw
                    :label        = "$t('contract.esc.phoneCosts')"
                    :readonly     = "readonly"
                    v-model       = "unitData.phoneCosts"
                    :hide-details = "true"
                />
            </v-col>
            <v-col class="no-frame pl-1 col-4">
                <f-currency-field-rw
                    :label        = "$t('contract.esc.guardCosts')"
                    :readonly     = "readonly"
                    v-model       = "unitData.guardCosts"
                    :hide-details = "true"
                />
            </v-col>
        </v-row>
    </template>
 </c-contract-editor>
